import Icon from '../components/Icon';

const LocationFilled = Icon(
  'location-filled',
  <>
    <path d="M19.294 2.794 3.422 8.288A1.49 1.49 0 0 0 2.409 9.73a1.48 1.48 0 0 0 1.06 1.407l7.18 2.222 2.213 7.18a1.46 1.46 0 0 0 1.407 1.05h.028a1.48 1.48 0 0 0 1.415-1.012l5.494-15.872a1.5 1.5 0 0 0-1.912-1.912" />
  </>
);

export default LocationFilled;
